
$(document).ready(function() {
  if ($('.js-pagination').length > 0) {

    window.ShCustom = {};

    var paginationWrapper = $('.js-pagination');

    // GET SHOPIFY PAGINATION VARIABLES
    ShCustom.currentPage =  parseInt(paginationWrapper.data('p-current'), 10);
    ShCustom.totalPosts	= parseInt(paginationWrapper.data('p-items'), 10);
    ShCustom.initialNextUrl	= paginationWrapper.data('p-next-url');
    ShCustom.postsPerPage	= parseInt(paginationWrapper.data('p-by'), 10);
    ShCustom.sortUrl	= '';
    ShCustom.totalPages = Math.ceil(ShCustom.totalPosts / ShCustom.postsPerPage);


    // ONLY RUN PAGINATION IF USER IS ON FIRST PAGE,
    // DEFAULT PAGINATION IS PREFERRED IF THEY NAVIGATE THERE BY A LINK
    if (ShCustom.currentPage == 1 && ShCustom.totalPosts > ShCustom.postsPerPage) {

      // Hide fallback pagination if js loads and we're on the first page
      $('.pagination .fallback').hide();
      $('.js-load-more').removeClass('hide');

      // GET BASE PAGINATION URL FOR AJAX REQUESTS
      ShCustom.paginationBaseUrl = ShCustom.initialNextUrl.split("?")[0];

      // REFS
      var endlessScrollContainer	= '.js-ajax-items';
      var paginationWrapper	= '.js-pagination';
      var ajaxLoadMoreLink	= $('.js-load-more');

      // TOGGLED WHILE WAITING FOR A REQUEST TO LOAD TO PREVENT DUPLICATE REQUESTS
      var gAjaxStatus = false;


      // AJAX LOAD NEXT PAGE ======================
      function ajaxLoadNextPage () {
        var currentPage = ShCustom.currentPage;
        var separator = ShCustom.paginationBaseUrl.includes('sort_by') ? '&' : '?';
        var paginationNextUrl = ShCustom.paginationBaseUrl + separator + 'page=' + (currentPage + 1) ;

        $.ajax({
          type: 'GET',
          dataType: 'html',
          url: paginationNextUrl,
          success: function(data) {

            // GET HTML FROM RESPONSE (Will contain entire HTML page fragment)
            // Find the journal list from the next page
            var filteredData = $(data).find(endlessScrollContainer).html();

            // Append journal list to current journal list
            $(filteredData).appendTo(endlessScrollContainer);

            $('[data-stagger]').css({
              opacity: '1',
              transform: 'none'
            });

            // HIDE LOADER
            ajaxLoadMoreLink.find('.link-text').text('Load More');
            ajaxLoadMoreLink.removeClass('loading');

            // SET LOADING TO FALSE
            gAjaxStatus = false;

            // UPDATE PAGE NUMBER
            ShCustom.currentPage++;

            if (ShCustom.currentPage >= ShCustom.totalPages) {
              ajaxLoadMoreLink.hide();
            }

          }
        });
      }

      function endlessScrollLogic (e) {
        e.preventDefault();

        var currentPage = ShCustom.currentPage;
        // If page has pagination
        // If total items is greater than page number times number posts per page
        if (!gAjaxStatus && ShCustom.totalPosts > currentPage * ShCustom.postsPerPage) {

          gAjaxStatus = true;

          // SHOW LOADING ICON
          ajaxLoadMoreLink.show();
          ajaxLoadMoreLink.find('.link-text').text('Loading...');
          ajaxLoadMoreLink.addClass('loading');

          // LOAD NEXT PAGE
          ajaxLoadNextPage();

        }
      }

      // ENDLESS SCROLL ======================
      $('.js-load-more').on('click', endlessScrollLogic);


    }
  }

});
